<template lang="pug">
v-card#result-table
  table
    tr
      th {{ $t("result.list.phrase-count-title") }}
      td {{ result.clearQuestionCount }}
    tr
      th {{ $t("result.list.total-type-count-title") }}
      td {{ result.typeCountAll }}
    tr
      th {{ $t("result.list.correct-type-count-title") }}
      td {{ result.typeCount }}
    tr
      th {{ $t("result.list.correct-ratio-title") }}
      td {{ result.correctTypeRatio }}％
    tr
      th {{ $t("result.list.word-poor-at-title") }}
      td {{ result.wordPoorAt }}
    tr
      th {{ $t("result.list.wps-title") }}
      td {{ result.wordPerSecond }}
</template>

<script>

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      resultState: state => state.Result
    }),
    result: function () {
      return this.resultState.result
    }
  }
}

</script>

<style>

#result-table {
  width: 50%;
}

tr {
  height: 30px;
}

td, th {
  padding: 15px;
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/GameResultListCard.vue